import { InfoCircleOutlined } from "@ant-design/icons";
import { BodhiCard, BodhiInput, BodhiTextarea } from "@bodhistreams/ui";
import { useId } from "react";
import { formatCertificateDate } from "./certificateUtils";
import "./CertificateForm.css";

const CertificateForm = ({ values, errors, setField }) => {
	const uid = useId();

	return (
		<BodhiCard
			className="cert-card"
			title="Certificate Details"
			hoverable={false}
		>
			<div className="cert-form">
				<div
					className={`cert-field${errors.business_name ? " cert-field-invalid" : ""}`}
				>
					<label className="cert-label" htmlFor={`${uid}-business`}>
						Business or Organization Name
						<span className="cert-label-req">*</span>
					</label>
					<BodhiInput
						id={`${uid}-business`}
						value={values.business_name}
						onChange={setField("business_name")}
						placeholder="Enter the business or venue name"
					/>
					{errors.business_name && (
						<span className="cert-error">{errors.business_name}</span>
					)}
				</div>

				<div
					className={`cert-field${errors.contact_name ? " cert-field-invalid" : ""}`}
				>
					<label className="cert-label" htmlFor={`${uid}-contact`}>
						Authorized Contact
						<span className="cert-label-req">*</span>
					</label>
					<BodhiInput
						id={`${uid}-contact`}
						value={values.contact_name}
						onChange={setField("contact_name")}
						placeholder="Contact person for the certificate"
					/>
					{errors.contact_name && (
						<span className="cert-error">{errors.contact_name}</span>
					)}
				</div>

				<div
					className={`cert-field cert-field-wide${errors.property_address ? " cert-field-invalid" : ""}`}
				>
					<label className="cert-label" htmlFor={`${uid}-address`}>
						Property Address
						<span className="cert-label-req">*</span>
					</label>
					<BodhiTextarea
						id={`${uid}-address`}
						rows={3}
						value={values.property_address}
						onChange={setField("property_address")}
						placeholder="Street, city, state, postal code, country"
					/>
					{errors.property_address && (
						<span className="cert-error">{errors.property_address}</span>
					)}
				</div>

				{/* Read straight from the account, so shown rather than edited. */}
				<div className="cert-readonly">
					<div className="cert-readonly-item">
						<span className="cert-readonly-label">Contact Email</span>
						<span className="cert-readonly-value">
							{values.contact_email || "Not set on your account"}
						</span>
					</div>
					<div className="cert-readonly-item">
						<span className="cert-readonly-label">Service Start Date</span>
						<span className="cert-readonly-value">
							{values.service_start_date
								? formatCertificateDate(values.service_start_date)
								: "Not available for your subscription"}
						</span>
					</div>
				</div>

				<div className="cert-callout">
					<InfoCircleOutlined className="cert-callout-icon" />
					<p className="cert-callout-text">
						Your contact email and service start date are taken from your
						account and cannot be edited here. The business details you enter
						are stored in this browser so you can regenerate the certificate
						later.
					</p>
				</div>
			</div>
		</BodhiCard>
	);
};

export default CertificateForm;
